// Auth API functions
// Uses Firebase authentication — token managed by Firebase SDK (not localStorage)

import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
} from 'firebase/auth';
import { auth } from './firebase';

// Login with Firebase
export async function login(email: string, password: string): Promise<boolean> {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true;
  } catch (error) {
    console.error('Login error:', error);
    return false;
  }
}

// Login with Google
export async function loginWithGoogle(): Promise<boolean> {
  try {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(auth, provider);
    return true;
  } catch (error) {
    console.error('Google login error:', error);
    return false;
  }
}

// Logout
export async function logout(): Promise<void> {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error('Logout error:', error);
  }
}
